module.exports = __webpack_public_path__ + "img/web4.147d4aa0.webp";